module.exports = __webpack_public_path__ + "assets/img/发货单待确认.d365e26a.svg";